import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "group grid md:grid-cols-[auto_1fr] gap-y-8 gap-x-12" }
const _hoisted_2 = {
  ref: "yearContainer",
  class: "text-history-year-mobile md:text-history-year-tablet xl:text-history-year-desktop font-semibold md:-mb-60 group-last:md:mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref: "year",
        class: _normalizeClass(["md:min-w-[4ch] tabular-nums bg-white text-black-800 2xl:ml-[41px]", [$options.inactiveYearClass, $options.hideYearClass]])
      }, _toDisplayString($props.year), 3)
    ], 512),
    _createElementVNode("div", {
      class: _normalizeClass(["grid gap-8", { 'md:grid-cols-2': $props.hasImage }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["self-end", { 'md:mb-6': $props.hasImage && $props.hasImageCaption }])
      }, [
        _renderSlot(_ctx.$slots, "text")
      ], 2),
      ($props.hasImage)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass({ 'md:order-first': $props.imagePosition === 'imageLeft' })
          }, [
            _renderSlot(_ctx.$slots, "image")
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}